import { render } from "./platform-notify-popup.vue?vue&type=template&id=b55d5272&scoped=true"
import script from "./platform-notify-popup.vue?vue&type=script&lang=js"
export * from "./platform-notify-popup.vue?vue&type=script&lang=js"

import "./platform-notify-popup.vue?vue&type=style&index=0&id=b55d5272&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b55d5272"]])

export default __exports__